import React from "react";

export const SurveyContext = React.createContext();
